var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export var NavButtons = function (_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.col, col = _c === void 0 ? false : _c;
    return (_jsx("nav", __assign({ className: classNames(className, 'container flex gap-4 p-4 mx-auto max-w-lg/2 flex-col', {
            'sm:flex-row flex-wrap': !col,
        }) }, { children: children })));
};
